import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PropTypes } from "prop-types";
import imgLogo from "../../../../../image/logo.png";
import api from "../../../../../utils/apidsf";
import swal from "sweetalert";
import RichTextEditor from "react-rte";
import { TextEditor } from "../../../Components/Jodti-RichTextEditor/RichTextEditor";

// import "./CreateArticle.css";

// components
import FormField from "../../../Components/FormField/FormField";

export default function CreateArticle() {
  const params = useParams();
  const navigate = useNavigate();
  //const [id, setId] = useState("");
  const [textareadata, settextdata] = useState({
    value: RichTextEditor.createEmptyValue(),
  });
  const [formData, setFormData] = useState({
    category: "terms",
    word: "",
    meaning_hin: "",
    Rechtextformeaning_hindi: RichTextEditor.createEmptyValue(),
    Rechtextformeaning_usage: "",
    usage: "",
    meaning_eng: "",
    Rechtextformeaning_english: RichTextEditor.createEmptyValue(),
  });

  const handleInputChange = (e) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let id = params.id;
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };

    const createOrUpdateLandmark = async () => {
      try {
        let res = null;
        if (id) {
          res = await api.put(`/legal-term-admin/${id}`, formData, config);
        } else {
          res = await api.post("/legal-term-admin/", formData, config);
        }
        const data = res.data.data;

        if (data && id) {
          swal({
            title: "Legal Term Updated",
            text: "Legal Term Updated Successfully",
            icon: "success",
          });
          navigate("/admin/legal-term-table");
        } else {
          setFormData({
            ...formData,

            category: "terms",
            word: "",
            meaning_hin: "",
            Rechtextformeaning_hindi: RichTextEditor.createEmptyValue(),
            usage: "",
            meaning_eng: "",
            Rechtextformeaning_english: RichTextEditor.createEmptyValue(),
            Rechtextformeaning_usage: "",
          });
          swal({
            title: "Legal Term Added",
            text: "Legal Term Added Successfully",
            icon: "success",
          });
          // show error
        }
      } catch (err) {
        console.error(err.response.data.error);
        swal({
          title: "Error",
          text: err.response.data.error,
          icon: "error",
        });
      }
    };
    createOrUpdateLandmark();
  };

  useEffect(() => {
    let id = params.id;

    const fetchLandmark = async () => {
      let token = JSON.parse(localStorage.getItem("token"));

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
      const res = await api.get(`/legal-term-admin/${id}`, config);
      const data = res.data.data;
      const { word, meaning_eng, meaning_hin, usage } = data;

      setFormData({
        category: category,
        word: word,
        meaning_eng: meaning_eng,
        Rechtextformeaning_hindi: RichTextEditor.createValueFromString(
          meaning_hin,
          "html"
        ),
        // Rechtextformeaning_usage: RichTextEditor.createValueFromString(
        //   usage,
        //   "html"
        // ),

        Rechtextformeaning_usage: usage,

        usage: usage,
        meaning_hin: meaning_hin,
        Rechtextformeaning_english: RichTextEditor.createValueFromString(
          meaning_eng,
          "html"
        ),
      });
    };

    if (id) {
      fetchLandmark();
    } else {
      setFormData({
        category: "terms",
        word: "",
        meaning_hin: "",
        Rechtextformeaning_hindi: RichTextEditor.createEmptyValue(),
        usage: "",
        meaning_eng: "",
        Rechtextformeaning_english: RichTextEditor.createEmptyValue(),
        Rechtextformeaning_usage: "",
      });
    }
  }, [params]);

  const onChangedescription_hindi = (value) => {
    let data = value.toString("html");

    setFormData({
      ...formData,
      meaning_hin: data,
      Rechtextformeaning_hindi: value,
    });
  };
  const onChangedescription_english = (value) => {
    let data = value.toString("html");

    setFormData({
      ...formData,
      meaning_eng: data,
      Rechtextformeaning_english: value,
    });
  };
  const onChangedescription_usage = (value) => {
    let data = value.toString("html");

    setFormData({
      ...formData,
      usage: data,
      Rechtextformeaning_usage: value,
    });
  };

  const {
    word,
    Rechtextformeaning_hindi,
    category,
    Rechtextformeaning_english,
    Rechtextformeaning_usage,
  } = formData;
  return (
    <div style={{ flex: 4 }}>
      <form action="" className="admin__userUpdateForm" onSubmit={handleSubmit}>
        <div className="userUpdateLeft">
          <FormField
            type="text"
            label="Word"
            placeholder="Word"
            value={word}
            name="word"
            handleChange={handleInputChange}
          />

          <div className="userUpdateItem">
            <label className="user__label">Select Category</label>
            <select
              value={category}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  category: e.target.value,
                });
              }}
            >
              <option value="terms">Terms</option>
              <option value="maxim">Maxim</option>
            </select>
          </div>

          <div className="userUpdateItem">
            <label className="user__label">Meaning in English</label>

            <RichTextEditor
              className="desc_area"
              value={Rechtextformeaning_english}
              onChange={onChangedescription_english}
            />
          </div>
          <div className="userUpdateItem">
            <label className="user__label">Meaning in hindi</label>

            <RichTextEditor
              className="desc_area"
              value={Rechtextformeaning_hindi}
              onChange={onChangedescription_hindi}
            />
          </div>

          <div className="userUpdateItem">
            <label className="user__label">Usage / Example</label>
            {/* <RichTextEditor
              className="desc_area"
              value={Rechtextformeaning_usage}
              onChange={onChangedescription_usage}
            /> */}

            <TextEditor
              setData={onChangedescription_usage}
              value={Rechtextformeaning_usage}
            />
          </div>

          <div>
            <button className="userUpdateButton" type="submit">
              {params.id ? "Update LegalTerm" : "Add LegalTerm"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
